import { createPortal } from 'react-dom'
import { useSyncExternalStore } from 'react'

import { IvyChatArrowUpIcon } from '@/components/marketing/ivy-chat-submit-button'
import { cn } from '@/lib/utils'

type MarketingScrollFabProps = {
  visible: boolean
}

function useIsClient() {
  return useSyncExternalStore(
    () => () => {},
    () => true,
    () => false
  )
}

export function MarketingScrollFab({ visible }: MarketingScrollFabProps) {
  const isClient = useIsClient()

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  if (!isClient) {
    return null
  }

  return createPortal(
    <button
      type="button"
      className={cn('marketing-scroll-fab', visible && 'marketing-scroll-fab--visible')}
      aria-label="Scroll to top"
      onClick={scrollToTop}
    >
      <IvyChatArrowUpIcon className="marketing-scroll-fab__icon" />
    </button>,
    document.body
  )
}
